<template>
  <div v-if="client">
    <c-row class="mb-3">
      <!--      <CCol>-->
      <!--        <router-link :to="{name: 'clients'}" class="button is-light">-->
      <!--          <span class="icon"><i class="fa fa-chevron-left"></i></span><span>All Clients</span>-->
      <!--        </router-link>-->
      <!--      </CCol>-->
      <c-col>
        <div />
        <c-button-group class="float-right">
          <c-button v-show="$auth.check('organisation-admin')" color="primary" @click="showEdit = true">
            <span class="icon"><i class="fa fa-pencil" /></span>
            <span>Edit</span>
          </c-button>
          <c-button
            v-show="$auth.check('organisation-admin')"
            color="danger"
            :disabled="sites.length > 0"
            @click="openModalConfirm()"
          >
            <span class="icon"><i class="fa fa-trash" /></span>
            <span>Delete</span>
          </c-button>
        </c-button-group>
      </c-col>
    </c-row>

    <c-card>
      <c-card-body>
        <h1 class="text-h6">
          <strong>{{ client.name }}</strong>
        </h1>
        <p v-show="client.contactName" class="text-h6 is-4">
          <strong>Contact:</strong>
          {{ client.contactName }}
        </p>
        <p v-show="client.contactEmailAddress" class="text-h6 is-4">
          <strong>Email:</strong>
          {{ client.contactEmailAddress }}
        </p>
        <document-info :doc="client"></document-info>

        <template v-if="sites.length && allowBetaFeatures">
          <div style="margin-bottom: 20px; margin-top: 20px">
            <c-button color="kb-green" :disabled="updateAllSitesRequestQueued" @click="openConfirmUpdateAllSites">
              <span class="icon"><i class="fa fa-plug" /></span>
              <span class="icon"><i class="cil-chart-line" /></span>
              <span>
                Update all unblocked plugins on
                <strong>{{ sites.length }}</strong>
                site{{ sites.length > 1 ? 's' : '' }}
              </span>
            </c-button>
          </div>
        </template>
      </c-card-body>
    </c-card>

    <c-tabs>
      <c-tab title="Sites" active>
        <site-list :sites="sites" :hide-header="true" :hide-add-site-button="true"/>
      </c-tab>
      <c-tab title="Email">
        <email-side-tabs :client="client"></email-side-tabs>
      </c-tab>
    </c-tabs>

    <confirm-modal
      :title="siteUpdateTitle()"
      :show.sync="showUpdateAllSites"
      :ok-text="'Start updating'"
      @update:confirm="doUpdateAllSites"
    >
      <div v-html="siteUpdateMessage()" />
    </confirm-modal>

    <confirm-modal title="Delete client" :show.sync="showModal" :ok-text="'Delete'" color="danger" @update:confirm="deleteClient">
      <div>Delete this client? Cannot undo.</div>
    </confirm-modal>

    <edit-client :client="client" :show="showEdit" @close="showEdit = false" @updated="updateData" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DocumentInfo from '../components/DocumentInfo';
import EmailSideTabs from '../components/clients/email/side-tabs';
import { buildEndpoint } from '@/libs/buildEndPoint';
import { goToPage } from '@/libs/ui/goToPage';
import ConfirmModal from '@/views/components/ConfirmModal';
import SiteList from '../components/site-list-v2';
import EditClient from '../components/clients/edit';

// import io from 'socket.io-client'
// const socket = io(buildEndpoint(''))

export default {
  name: 'ClientDetails',
  components: {
    ConfirmModal,
    DocumentInfo,
    SiteList,
    EmailSideTabs,
    EditClient,
  },

  data() {
    return {
      error: null,
      user: null,
      showEdit: false,
      showModal: false,
      confirmModal: null,
      client: null,
      sites: null,
      isUpdating: false,
      showUpdateAllSites: false,
      updateAllSitesRequestQueued: false,
    };
  },

  computed: mapGetters({
    siteUpdates: 'siteUpdates',
    allowBetaFeatures: 'allowBetaFeatures',
  }),

  created() {
    this.clientId = this.$route.params.clientId;
    this.get();
    // let _this = this
    // socket.emit('room', Vue.localStorage.get('mp-sid'))
    // socket.on('siteUpdateNotification', function (data) {
    //   console.log(`Site update complete for ${data.siteId}`)
    //   // if (['refresh-site'].indexOf(data.action) !== -1 && _this.siteId === data.siteId) {
    //   //   _this.isUpdatingAllPlugins = false
    //   //   _this.refreshSite()
    //   //   _this.refreshPluginLogs++
    //   // }
    // })
  },

  methods: {
    ...mapActions(['toggleNotifications', 'queueSiteUpdate']),
    closeUpdateAllSites() {
      this.showUpdateAllSites = false;
    },
    updateData(data) {
      this.client.name = data.name;
      this.client.contactName = data.contactName;
      this.client.contactEmailAddress = data.contactEmailAddress;
    },
    get() {
      this.$http
        .get(buildEndpoint('clients/get/') + this.clientId)
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            this.client = response.data.data.client;
            this.sites = response.data.data.nodes;
          } else {
            this.error = 'Error getting client data';
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error getting client data',
            });
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
    openModalConfirm() {
      this.showModal = true;
    },
    deleteClient() {
      this.showModal = false;
      this.error = null;
      this.$http
        .delete(buildEndpoint('clients/delete/') + this.clientId)
        .then((response) => {
          if (response.data.success) {
            goToPage(this.$router, { name: 'clients' });
          } else {
            this.error = 'Error deleting client data';
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error deleting client data',
            });
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
    siteUpdateTitle() {
      return ` Update all plugins for ${this.client.name}`;
    },
    siteUpdateMessage() {
      return `Update all plugins (except plugins you’ve blocked) for ${this.client.name}`;
    },
    openConfirmUpdateAllSites() {
      this.showUpdateAllSites = true;
    },
    doUpdateAllSites() {
      // Do updates
      this.updateAllSitesRequestQueued = true;
      this.showUpdateAllSites = false;
      this.$http
        .get(buildEndpoint('clients/sites/update/all-plugins/') + this.clientId)
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: response.data.message,
            });
            this.$store.commit('openSideBar');
          } else {
            this.error = 'There was a problem updating all sites for this client';
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: this.error,
            });
          }
        })
        .catch((error) => {
          this.updateAllSitesRequestQueued = false;
          this.error = error;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
//.buttons {
//  justify-content: space-between;
//  margin-bottom: 20px;
//  .button {
//    margin-left: 5px;
//    &:first-child {
//      margin-left: 0;
//    }
//  }
//}
//.tile {
//  &.buttons {
//    margin-bottom: 20px;
//    .button {
//      &.is-light {
//        &.is-active {
//          background: none;
//          box-shadow: none;
//        }
//      }
//    }
//  }
//}
//.error-message {
//  margin-bottom: 20px;
//}
</style>
